// Pure decisions for when client-side locale redirects/switches may run (see
// middleware/i18n-locale.global.ts and plugins/i18n-locale.client.ts).

/**
 * The route middleware must not redirect or switch locale while a server-rendered page is still
 * hydrating — the client would render different strings/routes than the server HTML.
 */
export const shouldSkipLocaleMiddleware = ({
  isHydrating,
  serverRendered,
}: {
  isHydrating: boolean | undefined;
  serverRendered: boolean | undefined;
}): boolean => Boolean(isHydrating && serverRendered);

/**
 * When the deferred post-hydration sync runs. `app:mounted` fires before async (Suspense) page
 * hydration completes; Nuxt flips `isHydrating` off and calls `app:suspense:resolve` only once
 * every Suspense boundary has hydrated. CSR-only loads never hydrate, so `app:mounted` is fine.
 */
export const localeSyncHook = (serverRendered: boolean | undefined): 'app:suspense:resolve' | 'app:mounted' =>
  serverRendered ? 'app:suspense:resolve' : 'app:mounted';
